import React, {useEffect,useState} from 'react';
import "./CampaignDesktop.scss";
import FooterDesktop from "../DesktopComponents/FooterDesktop/FooterDesktop";
import HeaderDesktop from "../DesktopComponents/HeaderDesktop/HeaderDesktop";
import {getMallMerchant_api} from "../../Services/apis";
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";
import {FestivalData} from "../Festival/FestivalServices";
import {useHistory} from "react-router";


export default function CampaignDesktop(){

    const history = useHistory()
    const [mId,set_mId]=useState(null);
    const [festivals,setFestivals] = useState(null);

    useEffect(()=>{
        getFestivals()
    },[])


    const getFestivals = async () => {
        try{
            let response = await FestivalData();
            setFestivals(response.data);
        }catch (e) {
        }
    }

    return(
        <div>
            <DrShopHeader home={true}/>

            <br/><br/>
            <div className="camp-list">


                {festivals?.map(f=>{
                    return(
                        <div className="camp-card" onClick={()=>{
                            history.push(`/festival-detail/${f.uid}`,{festival:f})
                        }}>
                            <div className="camp-card-img">
                                <img src={f.cover || f.image || "/other/skeleton/slide.jpg"} alt=""/>
                            </div>
                            <div className="camp-card-title">
                                <span>{f.title}</span>
                            </div>
                        </div>
                    )
                })}

            </div>

            <br/><br/>
            <FooterDesktop/>
        </div>
    )
}
